import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_c03b2305-10b0-43c0-8499-c191377bc941/artifacts/02yyq1u7_EconomicClubofSa.png';

export default function Footer() {
  return (
    <footer className="bg-brand-dark border-t border-brand-gold/10 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo/Brand */}
          <div className="flex items-center gap-3">
            <img 
              src={LOGO_URL} 
              alt="ECSA" 
              className="h-8 w-auto"
            />
            <span className="text-gray-400 text-sm">
               {new Date().getFullYear()} Economic Club of San Antonio™
            </span>
          </div>
          
          {/* Links */}
          <div className="flex items-center gap-6">
            <a 
              href="https://www.econclubsa.org/terms" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-brand-gold text-sm transition-colors"
            >
              Terms of Service
            </a>
            <a 
              href="https://www.econclubsa.org/privacy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-brand-gold text-sm transition-colors"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
